import { render } from "./editInvestment.vue?vue&type=template&id=94ef2c42&scoped=true"
import script from "./editInvestment.vue?vue&type=script&lang=js"
export * from "./editInvestment.vue?vue&type=script&lang=js"

import "./editInvestment.vue?vue&type=style&index=0&id=94ef2c42&scoped=true&lang=css"

import exportComponent from "E:\\workspace2017\\vue3.0\\premia-user-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ef2c42"]])

export default __exports__